export default {
  flash (context, opts) {
    context.commit('SET_FLASH_MESSAGES', opts.messages)
    context.commit('SET_FLASH_KIND', opts.kind)
    context.commit('SET_FLASH_TIMEOUT', opts.timeout)
    context.commit('SET_FLASH_VISIBLE', true)
  }
}
